// extracted by mini-css-extract-plugin
module.exports = {"selector":"_3i90_","selectorText":"_12RK0","selectorItem":"_2T8Yk"};